export default function FontSizeIcon({ ...props }) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor" {...props}>
			<path d="M570-146.999V-700H360v-113.001h533.001V-700h-210v553.001H570Zm-373.001 0v-340h-130V-600H440v113.001H310v340H196.999Z" />
		</svg>
	)
}
